import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ICulture, IXenaApp, IXenaAppBundle } from 'src/app/xena-api';

@Component({
    selector: 'app-translations',
    templateUrl: './translations.component.html',
    styleUrls: ['./translations.component.scss'],
    standalone: false
})
export class TranslationComponent {
  @Input() appTranslated: UntypedFormGroup;
  @Input() app: IXenaApp | IXenaAppBundle;
  @Input() selectedCulture: ICulture;
  @Input() isReadonly;
}
